// @flow
import { getTeamUrl } from 'Common';

export default ( version ) => async (dispatch: Function, getState: Function) => {

  const { id } = getState().screens.EstimateView.estimate;

  let url = `estimates/${id}/excel`;

  if (version === 'material') url += `&version=material`

  window.location = getTeamUrl(url, 'exports');

}
